import { Injectable } from '@angular/core';
import { ConfiguracoesProjeto, GenericHttpService, ParametrosService } from '..';
import { DadosAcessoCidadao } from '../../restrito/consumidor/shared/dados-acesso-cidadao';
import { Headers, Http } from '@angular/http';
import { Observable } from 'rxjs';

@Injectable()
export class CadastroSenhaCidadaoService {
  public _urlBase: string;
  public configuracao: ConfiguracoesProjeto;

  constructor(
    private readonly parametrosService: ParametrosService,
    private readonly genericHttpService: GenericHttpService<any>,
    private readonly http: Http
  ) {}

  get urlBase() {
    this.configuracao = this.parametrosService.getConfiguracao();
    this._urlBase = this.configuracao.uri + 'acesso-cidadao/cadastro-senha';

    return this._urlBase;
  }

  cadastrarSenha(dadosAcesso: DadosAcessoCidadao): Observable<any>{

        const headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        headers.append('npb', 'true');
        
        return this.genericHttpService.putAny(this.urlBase, dadosAcesso);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/shared/service/cadastro-senha-cidadao.service.ts